import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import RestrictDirected from "./RestrictDirected";

// Public Pages
import Login from "../Pages/Authentication/Login";
import CreateAccount from "../Pages/Authentication/CreateAccount/CreateAccount";
import MOUForm from "../Pages/MOUForm";

// Layouts
import Layout from "../Components/Layout/Layout";
import UserDashLayout from "../Components/Layout/UserDashLyout/UserDashLayout";

// Protected Pages
import Home from "../Pages/Home";
import Preferences from "../Pages/Preferences";
import { ListOfSports } from "../Pages/ListOfSports";
import { TimeSlot } from "../Pages/TimeSlot";
import { BuyPackages } from "../Pages/BuyPackages";
import { PackageDetails } from "../Pages/PackageDetails";
import { ConfirmationPopup } from "../Components/ConfirmationPopup";
import AddAChild from "../Pages/AddAChild";
import AddChildForm from "../Pages/AddChildForm";
import Dashboard from "../Pages/Dashboard";
import MySessions from "../Pages/MySessions";
import Fundraising from "../Pages/Fundraising";
import AfterSchoolProgram from "../Pages/AfterSchoolProgram";
import SummerCamp from "../Pages/SummerCamp";
import SchoolPrograms from "../Pages/SchoolPrograms";

// Sports Pages
import Soccer from "../Pages/Soccer";
import Football from "../Pages/Football";
import Baseball from "../Pages/Baseball";
import Basketball from "../Pages/Basketball";
import Golf from "../Pages/Golf";
import Fitness from "../Pages/Fitness";
import Bowling from "../Pages/Bowling";
import TrackAndField from "../Pages/TrackAndField";
import BirthdayPage from "../Pages/Birthday";
import Coaches from "../Pages/Coaches";

import FieldDays from "../Pages/FieldDays";
import Profile from "../Pages/UserDashboard/Profile/Profile";
import YourPlayers from "../Pages/UserDashboard/YourPlayers/YourPlayers";
import SavedPaymentMethod from "../Pages/UserDashboard/PaymentsBillings/SavedPaymentMethod/SavedPaymentMethod";
import PaymentHistory from "../Pages/UserDashboard/PaymentsBillings/PaymentHistory/PaymentHistory";
import MyPackagesPlans from "../Pages/UserDashboard/MyPackagesPlans/MyPackagesPlans";
import ChangePassword from "../Pages/UserDashboard/ChangePassword/ChangePassword";
import Notifications from "../Pages/UserDashboard/Notifications/NewNotify";

import { PaymentThankYou } from "../Pages/PaymentThankYou";
import { PaymentFailed } from "../Pages/PaymentFailed";
import { VerifyPayment } from "../Pages/VerifyPayment";

import { SessionSports } from "../Pages/SchduleSession/SessionSports";
import { BookSlots } from "../Pages/SchduleSession/BookSlots";
import { ConfirmBooking } from "../Pages/SchduleSession/ConfirmBooking";
import AllSessions from "../Pages/SchduleSession/AllSessions";
import AddNewCard from "../Pages/UserDashboard/PaymentsBillings/AddNewCard";

import Instruction from "../Pages/Instruction";

import SendOTP from "../Pages/ForgotPassword/SendOTP";
import VerifyOTP from "../Pages/ForgotPassword/VerifyOTP";
import ResetPassword from "../Pages/ForgotPassword/ResetPassword";
import NotFound from "../Pages/NotFound";
import ContactUs from "../Pages/ContactUs";
import Careers from "../Pages/Careers";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import SuccessFailPage from "../Pages/Broker-Confirmation/SuccessFailPage";

import { Cart } from "../Pages/Cart/Cart";
import { AddChild } from "../Pages/BuyPackageAddingChild/AddChild";
import ProccedToCheckOut from "../Pages/ProccedToCheckOut/ProccedToCheckOut";
import PaymentDetails from "../Pages/UserDashboard/PaymentDetails/PaymentDetails";
import SavedPaymentMethodForSelfDir from "../Pages/Authentication/SavedPaymentMethodForSelfDir/SavedPaymentMethodForSelfDir";
import ActivateAc from "../Pages/Authentication/ActivateAc/ActivateAc";
import EquipmentApparelStore from "../Pages/EquipmentApparelStore";

const Routing = () => {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="/login" element={<Login />} />
      <Route path="/create-an-account" element={<CreateAccount />} />
      <Route
        path="/add-card-self-dir"
        element={<SavedPaymentMethodForSelfDir />}
      />
      <Route path="/activate-account" element={<ActivateAc />} />

      {/* for broker  */}
      <Route path="/broker-response" element={<SuccessFailPage />} />
      <Route
        path="/mou-form"
        element={
          <PrivateRoute>
            <MOUForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/preferences"
        element={
          <PrivateRoute>
            <Preferences />
          </PrivateRoute>
        }
      />
      <Route
        path="/list-of-sports"
        element={
          <PrivateRoute>
            <ListOfSports />
          </PrivateRoute>
        }
      />
      <Route
        path="/time-slot"
        element={
          <PrivateRoute>
            <TimeSlot />
          </PrivateRoute>
        }
      />
      <Route
        path="/buy-packages"
        element={
          <RestrictDirected>
            <BuyPackages />
          </RestrictDirected>
        }
      />
      <Route
        path="/package-details"
        element={
          <PrivateRoute>
            <PackageDetails />
          </PrivateRoute>
        }
      />
      <Route path="/verify-payment" element={<VerifyPayment />} />
      <Route
        path="/payment-success"
        element={
          <PrivateRoute>
            <PaymentThankYou />
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-failed"
        element={
          <PrivateRoute>
            <PaymentFailed />
          </PrivateRoute>
        }
      />

      {/* SessionSports */}
      <Route
        path="/session-sports"
        element={
          <PrivateRoute>
            <RestrictDirected>
              <SessionSports />
            </RestrictDirected>
          </PrivateRoute>
        }
      />
      <Route
        path="/book-slots"
        element={
          <PrivateRoute>
            <BookSlots />
          </PrivateRoute>
        }
      />
      <Route
        path="/confirm-booking"
        element={
          <PrivateRoute>
            <ConfirmBooking />
          </PrivateRoute>
        }
      />
      <Route
        path="/confirmation-popup"
        element={
          <PrivateRoute>
            <ConfirmationPopup />
          </PrivateRoute>
        }
      />
      <Route
        path="/add-a-child"
        element={
          <PrivateRoute>
            <AddAChild />
          </PrivateRoute>
        }
      />
      <Route
        path="/add-child-form"
        element={
          <PrivateRoute>
            <AddChildForm />
          </PrivateRoute>
        }
      />

      {/* <Route path="/dashboard/self-direction" element={<PrivateRoute><Dashboard /></PrivateRoute>}/> */}
      {/* <Route path="/my-sessions" element={<PrivateRoute><MySessions /></PrivateRoute>}/> */}

      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/soccer" element={<Soccer />} />
        <Route path="/football" element={<Football />} />
        <Route path="/baseball" element={<Baseball />} />
        <Route path="/basketball" element={<Basketball />} />
        <Route path="/track-and-field" element={<TrackAndField />} />
        <Route path="/golf" element={<Golf />} />
        <Route path="/fitness" element={<Fitness />} />
        <Route path="/bowling" element={<Bowling />} />
        <Route path="/field-days" element={<FieldDays />} />
        <Route path="/school-programs" element={<SchoolPrograms />} />
        <Route path="/after-school-programs" element={<AfterSchoolProgram />} />
        <Route path="/summer-camp" element={<SummerCamp />} />
        <Route path="/birth-day-parties" element={<BirthdayPage />} />
        <Route path="/fundraising" element={<Fundraising />} />
        <Route path="/equipment-apparel" element={<EquipmentApparelStore />} />

        {/* Instruction */}
        <Route path="/instruction" element={<Instruction />} />
        <Route path="/instruction/soccer" element={<Soccer />} />
        <Route path="/instruction/football" element={<Football />} />
        <Route path="/instruction/baseball" element={<Baseball />} />
        <Route path="/instruction/basketball" element={<Basketball />} />
        <Route path="/instruction/golf" element={<Golf />} />
        <Route path="/instruction/fitness" element={<Fitness />} />
        <Route path="/instruction/bowling" element={<Bowling />} />
        <Route
          path="/instruction/track-and-field"
          element={<TrackAndField />}
        />

        <Route path="/coaches" element={<Coaches />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route
          path="/cart"
          element={
            <RestrictDirected>
              <Cart />
            </RestrictDirected>
          }
        />
        <Route path="/add-your-child" element={<AddChild />} />
        <Route
          path="/checkout"
          element={
            <RestrictDirected>
              <ProccedToCheckOut />
            </RestrictDirected>
          }
        />

        <Route path="/send-otp" element={<SendOTP />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Route>
      <Route
        element={
          <PrivateRoute>
            <UserDashLayout />
          </PrivateRoute>
        }
      >
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/your-players"
          element={
            <PrivateRoute>
              <YourPlayers />
            </PrivateRoute>
          }
        />
        <Route
          path="/saved-payment-method"
          element={
            <PrivateRoute>
              <SavedPaymentMethod />
            </PrivateRoute>
          }
        />
        <Route
          path="/AddNewCard"
          element={
            <PrivateRoute>
              <AddNewCard />
            </PrivateRoute>
          }
        />
        <Route
          path="/view-all-sessions"
          element={
            <PrivateRoute>
              <AllSessions />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-history"
          element={
            <PrivateRoute>
              <PaymentHistory />
            </PrivateRoute>
          }
        />
        <Route
          path="/my-package-plans"
          element={
            <PrivateRoute>
              <RestrictDirected>
                <MyPackagesPlans />
              </RestrictDirected>
            </PrivateRoute>
          }
        />
        <Route
          path="/my-payment-details"
          element={
            <PrivateRoute>
              <PaymentDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <PrivateRoute>
              <ChangePassword />
            </PrivateRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <PrivateRoute>
              <Notifications />
            </PrivateRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default Routing;
